<!-- ----------------------------------------------- -->
<template>
  <v-card class="tm-mb-vals-card" v-if="this.valuesList.length != 0">
    <v-data-table
      :headers="headersList"
      :items="valuesList"
      :items-per-page="this.valuesList.length"
      :mobile-breakpoint="0"
      item-key="cd"
      hide-default-footer
      disable-sort
      disable-filtering
      fixed-header
      height="100%"
      dense
      class="tm-mb-detail-stage-values-tbody"
    >
      <template v-slot:[`item.wtrtmp`]="{ item }">
        <span
          v-if="showWtrQualHighlight(item.wtrtmpOvcd)"
          class="tm-mb-detail-wtrqual-ovlvl-color-highlight"
          :rw-info-color="setWtrQualInfoColor(item.wtrtmpOvcd)"
        >
          {{ item.wtrtmp }}
        </span>
        <span v-else> {{ item.wtrtmp }} </span>
      </template>
      <template v-slot:[`item.ph`]="{ item }">
        <span
          v-if="showWtrQualHighlight(item.phOvcd)"
          class="tm-mb-detail-wtrqual-ovlvl-color-highlight"
          :rw-info-color="setWtrQualInfoColor(item.phOvcd)"
        >
          {{ item.ph }}
        </span>
        <span v-else> {{ item.ph }} </span>
      </template>
      <template v-slot:[`item.dox`]="{ item }">
        <span
          v-if="showWtrQualHighlight(item.doxOvcd)"
          class="tm-mb-detail-wtrqual-ovlvl-color-highlight"
          :rw-info-color="setWtrQualInfoColor(item.doxOvcd)"
        >
          {{ item.dox }}
        </span>
        <span v-else> {{ item.dox }} </span>
      </template>
      <template v-slot:[`item.conduct`]="{ item }">
        <span
          v-if="showWtrQualHighlight(item.conductOvcd)"
          class="tm-mb-detail-wtrqual-ovlvl-color-highlight"
          :rw-info-color="setWtrQualInfoColor(item.conductOvcd)"
        >
          {{ item.conduct }}
        </span>
        <span v-else> {{ item.conduct }} </span>
      </template>
      <template v-slot:[`item.turbdty`]="{ item }">
        <span
          v-if="showWtrQualHighlight(item.turbdtyOvcd)"
          class="tm-mb-detail-wtrqual-ovlvl-color-highlight"
          :rw-info-color="setWtrQualInfoColor(item.turbdtyOvcd)"
        >
          {{ item.turbdty }}
        </span>
        <span v-else> {{ item.turbdty }} </span>
      </template>
      <template v-slot:[`item.cod`]="{ item }">
        <span
          v-if="showWtrQualHighlight(item.codOvcd)"
          class="tm-mb-detail-wtrqual-ovlvl-color-highlight"
          :rw-info-color="setWtrQualInfoColor(item.codOvcd)"
        >
          {{ item.cod }}
        </span>
        <span v-else> {{ item.cod }} </span>
      </template>
      <template v-slot:[`item.amn`]="{ item }">
        <span
          v-if="showWtrQualHighlight(item.amnOvcd)"
          class="tm-mb-detail-wtrqual-ovlvl-color-highlight"
          :rw-info-color="setWtrQualInfoColor(item.amnOvcd)"
        >
          {{ item.amn }}
        </span>
        <span v-else> {{ item.amn }} </span>
      </template>
      <template v-slot:[`item.slt`]="{ item }">
        <span
          v-if="showWtrQualHighlight(item.sltOvcd)"
          class="tm-mb-detail-wtrqual-ovlvl-color-highlight"
          :rw-info-color="setWtrQualInfoColor(item.sltOvcd)"
        >
          {{ item.slt }}
        </span>
        <span v-else> {{ item.slt }} </span>
      </template>
    </v-data-table>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [MB]水質 観測値カード
 * TmWtrQualValues.vue
 * @author ILUKE
 */

export default {
  name: "tm-wtr-qual-values",
  data() {
    return {};
  },
  computed: {
    /**
     * 表示時刻設定(0:時間単位、1:10分単位) 取得
     */
    timeMode: {
      get() {
        return this.$store.state.Telemeter.timeMode;
      }
    },
    /**
     * ヘッダ情報 取得
     */
    headersList: {
      get() {
        // 時間単位
        return this.hourList.headers;
      }
    },
    /**
     * 観測値一覧 取得
     */
    valuesList: {
      get() {
        // 時間単位
        return this.hourList.values;
      }
    },
    /**
     * 水質情報(時間) 取得
     */
    hourList: {
      get() {
        return this.$store.state.Telemeter.selectedTm.obsValues.hour;
      }
    }
  },
  methods: {
    /**
     * 超過観測所 着色
     */
    setWtrQualInfoColor(Ovcd) {
      if (Ovcd === 1 || Ovcd === 2) {
        return "danger";
      }
    },
    /** 超過基準水位名を表示するか */
    showWtrQualHighlight(Ovcd) {
      if (Ovcd === 1 || Ovcd === 2) {
        return true;
      }
      return false;
    },
  }
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
</style>